import {
    getAllUserRouteStatus,
    recalculateScore,
    UserClimbingRoute,
    UserRouteStatus
} from "../../../models/UserClimbingEvent";
import React, {FC, useState} from "react";
import {Box} from "@mui/system";
import {Alert, Button, MenuItem, Select, TextField} from "@mui/material";
import {ClimbingEvent} from "../../../models/ClimbingEvent";
import {findUserByCompetitionNameAndUpdate} from "../../../services/events/UserEventService";
import {Alarm} from "@mui/icons-material";

type Props = {
    event: ClimbingEvent
}

type NumberToRoute = {
    compNumber: number,
    routeId: number,
    newStatus: UserRouteStatus
}
export const AddCompetitionPoints: FC<Props> = ({event}) => {

    const [numberToRoute, setNumberToRoute] = useState<NumberToRoute>({
        compNumber: 0,
        routeId: 1,
        newStatus: UserRouteStatus.DONE
    })

    const [successMessage, setSuccessMessage] = useState<string>()
    const [errorMessage, setErrorMessage] = useState<string>()

    const updateNumber = (value: string) => {
        setNumberToRoute({...numberToRoute, compNumber: parseInt(value)})
        setErrorMessage(undefined)
        setSuccessMessage(undefined)
    }
    
    const onClick = () => {
        findUserByCompetitionNameAndUpdate(numberToRoute.compNumber.toString(), event, numberToRoute.routeId, numberToRoute.newStatus)
            .then((result) => {
                if (result) {
                    setSuccessMessage(`Zaktualizowano ${result.name} z numerem ${result.startNumber} na status ${numberToRoute.newStatus} na drodze ${numberToRoute.routeId}`)
                    setErrorMessage(undefined)
                } else {
                    setErrorMessage("Nie znaleziono zawodnika")
                    setSuccessMessage(undefined)
                }
            }).catch((e) => {
            setErrorMessage(e)
            setSuccessMessage(undefined)
        })
    }

    return (
        <Box display={'flex'} flexDirection={'column'} gap={2}>

            <TextField
                label="Numer startowy"
                value={numberToRoute.compNumber}
                onChange={(e) => {
                    updateNumber(e.target.value)

                }}
                type={"number"}
            />
            <TextField
                label="Numer drogi"
                value={numberToRoute.routeId}
                onChange={(e) => {
                    setNumberToRoute({...numberToRoute, routeId: parseInt(e.target.value)})
                }}
                type={"number"}
            />
            <Select
                label="Status"
                value={numberToRoute.newStatus}
                onChange={(e) => {
                    setNumberToRoute({...numberToRoute, newStatus: e.target.value as UserRouteStatus})
                }}
            >
                {getAllUserRouteStatus(event).filter(s => s.status !== UserRouteStatus.NOTHING).map((s) => {
                    return (
                        <MenuItem key={s.status} value={s.status}>{s.status}</MenuItem>
                    )
                })}
            </Select>

            <Button onClick={() => {
                onClick()
            }}>Zapisz</Button>
            {successMessage && <Alert severity="success">{successMessage}</Alert>}
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </Box>
    )
}